import { cn } from '../../../../lib/utils';
import { InfoFill } from '@crabs-ai/web-icons';
import { cva } from 'class-variance-authority';

const infomationBoxVariants = cva(
  ['group flex flex-col bg-comp-info-box-default-bg transition-all'],
  {
    variants: {
      type: {
        default: [''],
        negative: ['bg-comp-info-box-negative-bg'],
        info: ['bg-comp-info-box-info-bg'],
      },
      form: {
        container: ['rounded-xs', 'px-sm py-xs'],
        banner: ['layout-padding-side py-sm'],
        footer: ['layout-padding-side pt-sm layout-padding-bottom'],
      },
    },
  },
);

export interface InformationBoxProps {
  type: 'default' | 'negative' | 'info';
  form: 'container' | 'banner' | 'footer';
  title?: React.ReactNode;
  description?: React.ReactNode;
  isShowLeadingIcon?: boolean;
  leadingIconNode?: React.ReactNode;
}

export default function InformationBox({
  type = 'default',
  form = 'container',
  title,
  description,
  isShowLeadingIcon = true,
  leadingIconNode,
  ...props
}: InformationBoxProps & React.ComponentProps<'div'>) {
  if (!title && !description) {
    return <></>;
  }

  const { className, ...rest } = props;

  return (
    <div
      data-type={type}
      className={cn(infomationBoxVariants({ type, form }), className)}
      {...rest}
    >
      <div className="flex items-center gap-4xs text-title-small">
        {isShowLeadingIcon && (
          <div
            className={cn(
              '[&_svg]:size-[16px]',
              'group-data-[type=default]:[&_path]:fill-comp-info-box-default-icon',
              'group-data-[type=negative]:[&_path]:fill-comp-info-box-negative-icon',
              'group-data-[type=info]:[&_path]:fill-comp-info-box-default-icon',
              '[&_path]:transition-all',
            )}
          >
            {leadingIconNode || <InfoFill />}
          </div>
        )}
        {title && (
          <div
            className={cn(
              'group-data-[type=default]:text-comp-info-box-default-text',
              'group-data-[type=negative]:text-comp-info-box-negative-text',
              'group-data-[type=info]:text-comp-info-box-info-text',
              'transition-all',
            )}
          >
            {title}
          </div>
        )}
      </div>
      {description && (
        <div className="text-body-small">
          <div className="text-comp-info-box-description-text">
            {description}
          </div>
        </div>
      )}
    </div>
  );
}
